import type { AllRouteEndpoints } from "../routeTypes";
export const appsMultiLanguageSettingsUploadTranslationsCacheKeys: AllRouteEndpoints[] = [];
